"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
require("react-responsive-modal/styles.css");
var _reactResponsiveModal = _interopRequireDefault(require("react-responsive-modal"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactDropzone = _interopRequireDefault(require("react-dropzone"));
var _reactSwitch = _interopRequireDefault(require("react-switch"));
var _functions = require("../../util/functions");
require("rc-checkbox/assets/index.css");
var _fontawesomeSvgCore = require("@fortawesome/fontawesome-svg-core");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
require("react-dropdown/style.css");
require("./DownloadPdf.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
_fontawesomeSvgCore.library.add(_freeSolidSvgIcons.faCircleNotch);
var reactDropdownStyles = {
  control: function control(styles, _ref) {
    var data = _ref.data,
      isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected;
    return _objectSpread(_objectSpread({}, styles), {}, {
      border: 0,
      // This line disable the blue border
      boxShadow: 0,
      fontSize: 16,
      color: '#5B6770',
      '&:hover': {
        border: 0
      }
    });
  },
  singleValue: function singleValue() {
    return {
      color: '#5B6770',
      fontSize: 16
    };
  },
  placeholder: function placeholder() {
    return {
      color: '#BDC2C6'
    };
  },
  dropdownIndicator: function dropdownIndicator() {
    return {
      color: '#596770',
      paddingTop: '4px'
    };
  },
  indicatorSeparator: function indicatorSeparator() {
    return null;
  },
  option: function option(styles, _ref2) {
    var data = _ref2.data,
      isDisabled = _ref2.isDisabled,
      isFocused = _ref2.isFocused,
      isSelected = _ref2.isSelected;
    return _objectSpread(_objectSpread({}, styles), {}, {
      marginTop: '0px',
      '&:hover': {
        color: '#FFF',
        cursor: 'pointer'
      },
      '&:isSelected': {
        color: '#FFF'
      },
      '&:isFocused': {
        color: '#FFF'
      }
    });
  }
};
var DownloadPdf = /*#__PURE__*/function (_PureComponent) {
  _inherits(DownloadPdf, _PureComponent);
  var _super = _createSuper(DownloadPdf);
  function DownloadPdf(props) {
    var _this;
    _classCallCheck(this, DownloadPdf);
    _this = _super.call(this, props);
    _this.handleOpenModal = _this.handleOpenModal.bind(_assertThisInitialized(_this));
    _this.handleCloseModal = _this.handleCloseModal.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.handleSelectDropdown = _this.handleSelectDropdown.bind(_assertThisInitialized(_this));
    _this.handleDropzoneChange = _this.handleDropzoneChange.bind(_assertThisInitialized(_this));
    _this.handleEnterPress = _this.handleEnterPress.bind(_assertThisInitialized(_this));
    _this.handleChangeCheckBox = _this.handleChangeCheckBox.bind(_assertThisInitialized(_this));
    _this.handleShowLogo = _this.handleShowLogo.bind(_assertThisInitialized(_this));
    _this.state = {
      config: null,
      waitingForPdf: false,
      userLogo: null,
      openModal: _this.props.openModalOnLoad,
      errorGeneratingPdf: false,
      showLogo: true,
      accentColor: '#05A9B1'
    };

    // Create ref for the accent styles
    _this.styleRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  // Set up the state to have default values for the dynamically loaded inputs
  _createClass(DownloadPdf, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var styles = getComputedStyle(this.styleRef.current);
      this.setState({
        accentColor: (0, _functions.convertRgbToHex)(styles.color)
      });

      // Get the config for the app
      this.getConfig();
    }

    /********************************************* 
     * Async methods for api interactions
    **********************************************/
  }, {
    key: "getConfig",
    value: function () {
      var _getConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var _this$props, dataspanApiUrl, token, configId, requestId;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, dataspanApiUrl = _this$props.dataspanApiUrl, token = _this$props.token, configId = _this$props.configId;
                if (!(token !== undefined)) {
                  _context.next = 4;
                  break;
                }
                // Get the document config from Dataspan
                requestId = {
                  method: 'GET',
                  url: "".concat(dataspanApiUrl, "/pdf/").concat(configId, "/")
                };
                return _context.abrupt("return", (0, _axios.default)(requestId).then(function (d) {
                  if (d.status === 404) {
                    return;
                  } else {
                    return d.data;
                  }
                }).then(function (data) {
                  // If the ID exists then get the logo itself
                  if (data.id === configId) {
                    // Store the config for later user (on a reinitialize)
                    _this2.setState({
                      config: data
                    });
                    _this2.initializeInputs(data);

                    // // Get the logo once the config has been loaded
                    _this2.getUserLogo();
                  }
                }).catch(function (error) {
                  console.error(error);
                }));
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getConfig() {
        return _getConfig.apply(this, arguments);
      }
      return getConfig;
    }()
  }, {
    key: "getUserLogo",
    value: function () {
      var _getUserLogo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3 = this;
        var _this$props2, dpdApiUrl, token, clientEmail, isAnonymous, requestId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, dpdApiUrl = _this$props2.dpdApiUrl, token = _this$props2.token, clientEmail = _this$props2.clientEmail, isAnonymous = _this$props2.isAnonymous;
                if (!(token !== 'undefined' && clientEmail && !isAnonymous)) {
                  _context2.next = 4;
                  break;
                }
                // Get the client's logo id from DPD - DPD stores and handles all client logos rather
                // than DataSpan
                requestId = {
                  method: 'GET',
                  url: "".concat(dpdApiUrl, "/api/image/logo/").concat(clientEmail, "/id/"),
                  headers: {
                    Authorization: token && "Token ".concat(token)
                  }
                };
                return _context2.abrupt("return", (0, _axios.default)(requestId).then(function (d) {
                  if (d.status === 404) {
                    return;
                  } else {
                    return d.data;
                  }
                }).then(function (data) {
                  // If the ID exists then get the logo itself
                  if (data.id) {
                    _this3.loadUserLogo(data.id);
                  }
                }).catch(function (error) {
                  console.error(error);
                }));
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getUserLogo() {
        return _getUserLogo.apply(this, arguments);
      }
      return getUserLogo;
    }() // Load the logo into state
  }, {
    key: "loadUserLogo",
    value: function loadUserLogo(id) {
      var dpdApiUrl = this.props.dpdApiUrl;

      // Put together the URL to the logo
      var imageUrl = dpdApiUrl + '/api/image/logo/lookup/?id=' + id;

      // If there any logo inputs then update with the latest
      // url for the user
      var inputsWithLogo = this.state.inputs.map(function (input) {
        var updatedInput = Object.assign({}, input);
        if (updatedInput.inputType === 'logo') {
          updatedInput.value = imageUrl;
        }
        return updatedInput;
      });

      // Save the logo
      this.setState({
        userLogo: {
          'imageId': id,
          'imageUrl': imageUrl
        },
        inputs: inputsWithLogo
      });
    }

    // Save a user's logo using DPD
  }, {
    key: "saveUserLogo",
    value: function () {
      var _saveUserLogo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(fileToSave) {
        var _this4 = this;
        var _this$props3, dpdApiUrl, token, clientEmail, isAnonymous, formData, request;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props3 = this.props, dpdApiUrl = _this$props3.dpdApiUrl, token = _this$props3.token, clientEmail = _this$props3.clientEmail, isAnonymous = _this$props3.isAnonymous;
                if (!(token !== 'undefined' && clientEmail || isAnonymous)) {
                  _context3.next = 8;
                  break;
                }
                formData = new FormData();
                formData.append('imageData', fileToSave);
                formData.append('clientEmail', clientEmail);
                formData.append('fileName', fileToSave.name);
                if (!isAnonymous) {
                  request = {
                    method: 'POST',
                    url: "".concat(dpdApiUrl, "/api/image/logo/"),
                    data: formData,
                    headers: {
                      Authorization: token && "Token ".concat(token)
                    }
                  };
                } else {
                  request = {
                    method: 'POST',
                    url: "".concat(dpdApiUrl, "/api/image/logo/add_anon/"),
                    data: formData
                  };
                }
                return _context3.abrupt("return", (0, _axios.default)(request).then(function (d) {
                  if (d.status === 404) {
                    return;
                  } else {
                    return d.data;
                  }
                }).then(function (data) {
                  // Save the new id if the post was successful
                  if (data.id) {
                    _this4.loadUserLogo(data.id);
                  }
                }).catch(function (error) {
                  console.error(error);
                }));
              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function saveUserLogo(_x) {
        return _saveUserLogo.apply(this, arguments);
      }
      return saveUserLogo;
    }()
  }, {
    key: "generatePdf",
    value: function () {
      var _generatePdf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(documentProperties, adhocInputs, outputName) {
        var _this5 = this;
        var _this$props4, dataspanApiUrl, token, clientEmail, isAnonymous, configId, inputs, body, request;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$props4 = this.props, dataspanApiUrl = _this$props4.dataspanApiUrl, token = _this$props4.token, clientEmail = _this$props4.clientEmail, isAnonymous = _this$props4.isAnonymous, configId = _this$props4.configId; // Don't send in the input if its value is empty. Divide percentage values by 100
                inputs = adhocInputs.filter(function (input) {
                  return input.value !== undefined && input.value !== null && input.value !== '';
                }).map(function (input) {
                  return {
                    'name': input.name,
                    'type': input.type,
                    'value': input.inputType === 'percentage' ? parseFloat(input.value) / 100 : input.value
                  };
                });
                body = {
                  clientEmail: clientEmail,
                  teamSiteId: documentProperties.teamSiteId,
                  libraryContentVersionId: documentProperties.libraryContentVersionId,
                  outputName: outputName,
                  adhocInputs: inputs,
                  id: configId
                };
                if (!(token !== 'undefined' && clientEmail || isAnonymous)) {
                  _context4.next = 6;
                  break;
                }
                // If this is an anonymous generation then don't add the token
                if (!isAnonymous) {
                  request = {
                    method: 'POST',
                    responseType: 'blob',
                    url: "".concat(dataspanApiUrl, "/pdf/generate/"),
                    data: body,
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization: token && "Token ".concat(token)
                    }
                  };
                } else {
                  request = {
                    method: 'POST',
                    responseType: 'blob',
                    url: "".concat(dataspanApiUrl, "/pdf/generate_with_id/"),
                    data: body,
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  };
                }
                return _context4.abrupt("return", (0, _axios.default)(request).then(function (response) {
                  // If the generate has been cancelled then ignore the save
                  if (_this5.state.waitingForPdf) {
                    //1. Create a Blob from the PDF Stream
                    var file = new Blob([response.data], {
                      type: 'application/pdf'
                    });
                    // 2. Create blob link to download
                    var url = URL.createObjectURL(file);
                    var link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.setAttribute('download', "".concat(outputName, ".pdf"));

                    // 3. Check if the user agent is not Chrome on mobile, need to manually open tab if so
                    if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                      // window event not working here
                      document.location = link.href;
                    } else {
                      // 4. Force a mouse click and then remove the link
                      var evt = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                      });
                      link.dispatchEvent(evt);
                      (window.URL || window.webkitURL).revokeObjectURL(link.href);
                    }

                    // // 3. Append to html page
                    // document.body.appendChild(link);
                    // // 4. Force download
                    // link.click();
                    // // 5. Clean up and remove the link
                    // setTimeout(function(){ link.parentNode.removeChild(link); }, 3000);

                    _this5.handleCloseModal();
                  }
                }).catch(function (error) {
                  console.error(error);

                  // Set the error
                  _this5.setState({
                    errorGeneratingPdf: true
                  });
                  // this.handleCloseModal();
                }));
              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function generatePdf(_x2, _x3, _x4) {
        return _generatePdf.apply(this, arguments);
      }
      return generatePdf;
    }()
    /********************************************* 
    * Input methods and change handlers
    **********************************************/
    // Wipe out the inputs and set back to original defaults
  }, {
    key: "initializeInputs",
    value: function initializeInputs(config) {
      var _this6 = this;
      if (config && config.adhocInputs) {
        // Initialize the input 
        var initializedInputs = config.adhocInputs.map(function (input) {
          var updatedInput = Object.assign({}, input);
          if (updatedInput.inputType === 'logo') {
            updatedInput.value = _this6.state.userLogo ? _this6.state.userLogo.imageUrl : null;
          }
          return updatedInput;
        });
        this.setState({
          docConfig: config,
          documentProperties: {
            teamSiteId: config.teamSiteId,
            libraryContentVersionId: config.libraryContentVersionId,
            outputName: config.outputName,
            contentName: config.contentName
          },
          inputs: initializedInputs
        });

        // Update the inputs with the passed in Adhoc inputs (if the calling app wants to 'hard code' inputs)            
        this.updatePropAdhocInputs(config);
      }
    }

    // Update all inputs with the passed into Adhoc Inputs (via prop adhocInput).
  }, {
    key: "updatePropAdhocInputs",
    value: function updatePropAdhocInputs(config) {
      var _this7 = this;
      var _this$props5 = this.props,
        adhocInputs = _this$props5.adhocInputs,
        clientEmail = _this$props5.clientEmail;
      if (config && config.adhocInputs && adhocInputs) {
        // Initialize the input 
        var updatedInputs = config.adhocInputs.map(function (input) {
          var updatedInput = Object.assign({}, input);

          // Ensure the logo is always added back from state. This could be overriden below if necessary
          if (updatedInput.inputType === 'logo') {
            updatedInput.value = _this7.state.userLogo ? _this7.state.userLogo.imageUrl : null;
          }

          // Add the email address of client to fields as necessary
          if (updatedInput.inputType === 'clientEmail') {
            updatedInput.value = clientEmail ? clientEmail : null;
          }
          var matchingAdhocInput = adhocInputs.filter(function (adhocInput) {
            return adhocInput.name === updatedInput.name;
          });

          // Set the value of the input to the incoming prop adhoc input value
          if (matchingAdhocInput.length === 1 && updatedInput.inputType !== 'dropdown') {
            updatedInput.value = matchingAdhocInput[0].value;
            updatedInput.label = matchingAdhocInput[0].label ? matchingAdhocInput[0].label : updatedInput.label;

            // If the input is a dropdown then set the options
          } else if (matchingAdhocInput.length === 1 && updatedInput.inputType === 'dropdown') {
            // Update the options if passed in as props
            if (matchingAdhocInput[0].options) {
              updatedInput.options = matchingAdhocInput[0].options;
            }

            // If a value was passed in, the caller wants a specific option to be highlighted, make sure
            // it matches one of the options.
            if (matchingAdhocInput[0].value) {
              var matchingOption = updatedInput.options.filter(function (option) {
                return option.value === matchingAdhocInput[0].value;
              });
              if (matchingOption.length === 1) {
                updatedInput.value = matchingOption[0].value;
                updatedInput.label = matchingOption[0].label;
              }
            }
          }
          return updatedInput;
        });
        this.setState({
          inputs: updatedInputs
        });
      }
    }

    // Iterate the inputs and ensure all are filled in
  }, {
    key: "allInputsValid",
    value: function allInputsValid() {
      var _this$props6 = this.props,
        percentageMin = _this$props6.percentageMin,
        percentageMax = _this$props6.percentageMax;
      var inputs = this.state.inputs;
      var allComplete = false;
      if (inputs) {
        allComplete = true;

        // Loop over each input and check the values
        inputs.forEach(function (input) {
          if ((input.optional === null || input.optional === false) && (input.value === undefined || input.value === null || input.value === '') ||
          // Check that percentage fields are within limits
          input.inputType === 'percentage' && (input.value < percentageMin || input.value > percentageMax)) {
            allComplete = false;
          }
        });
      }
      return allComplete;
    }

    // Handle open of modal
  }, {
    key: "handleOpenModal",
    value: function handleOpenModal() {
      // Submit right away if all the inputs are there and the app hasn't
      // been overriden to always show the modal
      if (this.allInputsValid() && this.props.submitOnLoad) {
        this.handleSubmit();
      } else {
        this.initializeInputs(this.state.config);
        this.setState({
          openModal: true
        });
      }
    }

    // Handle close of modal
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      var callbackOnClose = this.props.callbackOnClose;
      this.setState({
        openModal: false,
        waitingForPdf: false,
        errorGeneratingPdf: false
      });

      // If a callback is provided then call it
      if (callbackOnClose) {
        callbackOnClose();
      }
      this.initializeInputs(this.state.config);
    }

    // Handle all updates
  }, {
    key: "updateInput",
    value: function updateInput(name, value, label) {
      // Update the input
      var updatedInputs = this.state.inputs.map(function (input) {
        var updatedInput = Object.assign({}, input);
        if (updatedInput.name === name) {
          updatedInput.value = value;
          updatedInput.label = label;
        }
        return updatedInput;
      });
      this.setState({
        inputs: updatedInputs
      });
    }

    // Update the state with changes to inputs
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      this.updateInput(event.target.name, event.target.value, event.target.value);
    }

    // Update the state with changes to checkbox inputs
  }, {
    key: "handleChangeCheckBox",
    value: function handleChangeCheckBox(name, value) {
      this.updateInput(name, value, value);
    }

    // Handle events from drop downs
  }, {
    key: "handleSelectDropdown",
    value: function handleSelectDropdown(name, value, label) {
      this.updateInput(name, value, label);
    }

    // Handle events from dropzones
  }, {
    key: "handleDropzoneChange",
    value: function handleDropzoneChange(input, acceptedFiles) {
      if (acceptedFiles.length > 0) {
        this.saveUserLogo(acceptedFiles[0]);
      }
    }

    // Handle showing or hiding the logo
  }, {
    key: "handleShowLogo",
    value: function handleShowLogo() {
      var _this8 = this;
      // If there is a logo then update the value (based on whether the user wants to show/hide it)
      if (this.state.userLogo) {
        var imageUrl = this.state.userLogo.imageUrl;

        // Turn on or off the logo inputs
        var inputsWithLogo = this.state.inputs.map(function (input) {
          var updatedInput = Object.assign({}, input);

          // showLogo hasn't been updated yet so check the opposite to see if it needs adding or removing
          if (updatedInput.inputType === 'logo' && !_this8.state.showLogo) {
            updatedInput.value = imageUrl;
          } else if (updatedInput.inputType === 'logo' && _this8.state.showLogo) {
            updatedInput.value = null;
          }
          return updatedInput;
        });
        this.setState({
          inputs: inputsWithLogo,
          showLogo: !this.state.showLogo
        });
      } else {
        this.setState({
          showLogo: !this.state.showLogo
        });
      }
    }

    // Handle enter press (if button enabled)
  }, {
    key: "handleEnterPress",
    value: function handleEnterPress(event) {
      if (event.keyCode === 13 && this.allInputsValid()) {
        this.handleSubmit();
      }
    }

    // Submit the inputs to pdf generator
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this$state = this.state,
        inputs = _this$state.inputs,
        documentProperties = _this$state.documentProperties;

      // Update the output name if necessary
      var outputName = documentProperties.outputName;
      inputs.forEach(function (input) {
        outputName = outputName.replace("[[" + input.name + "]]", input.label ? input.label : '');
      });

      // Close the model and show the waiting indicator
      this.setState({
        openModal: false,
        waitingForPdf: true
      });

      // Generate the pdf
      this.generatePdf(documentProperties, inputs, outputName);

      // Reset all fields
      this.initializeInputs(this.state.config);
    }
  }, {
    key: "render",
    value: function render() {
      var _this9 = this;
      var _this$props7 = this.props,
        downloadButtonText = _this$props7.downloadButtonText,
        cancelButtonText = _this$props7.cancelButtonText,
        modalTitleText = _this$props7.modalTitleText,
        waitingMessageText = _this$props7.waitingMessageText,
        initialButtonText = _this$props7.initialButtonText,
        errorGeneratingPdfText = _this$props7.errorGeneratingPdfText,
        openModalOnLoad = _this$props7.openModalOnLoad,
        closeWindowText = _this$props7.closeWindowText,
        showCloseText = _this$props7.showCloseText,
        percentageMin = _this$props7.percentageMin,
        percentageMax = _this$props7.percentageMax;
      var _this$state2 = this.state,
        waitingForPdf = _this$state2.waitingForPdf,
        inputs = _this$state2.inputs,
        openModal = _this$state2.openModal,
        errorGeneratingPdf = _this$state2.errorGeneratingPdf,
        showLogo = _this$state2.showLogo,
        accentColor = _this$state2.accentColor;
      var inputFields = inputs ? inputs.map(function (input) {
        switch (input.inputType) {
          case 'text':
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, /*#__PURE__*/_react.default.createElement("input", {
              className: (0, _classnames.default)(input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : ''),
              type: input.inputType,
              name: input.name,
              value: input.value ? input.value : '',
              onChange: _this9.handleChange,
              placeholder: input.placeholder
            }));
          case 'textarea':
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, /*#__PURE__*/_react.default.createElement("textarea", {
              rows: "4",
              className: (0, _classnames.default)(input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : ''),
              type: input.type,
              name: input.name,
              value: input.value ? input.value : '',
              onChange: _this9.handleChange,
              placeholder: input.placeholder
            }));
          case 'dropdown':
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
              className: (0, _classnames.default)('wt-dropdown', input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : ''),
              placeholder: input.placeholder,
              onChange: function onChange(selectedItem) {
                _this9.handleSelectDropdown(input.name, selectedItem.value, selectedItem.label);
              },
              styles: reactDropdownStyles,
              theme: function theme(_theme) {
                return _objectSpread(_objectSpread({}, _theme), {}, {
                  borderRadius: 0,
                  colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
                    primary25: accentColor,
                    primary: accentColor
                  })
                });
              },
              options: input.options,
              isMulti: false,
              value: input.value ? {
                'value': input.value,
                'label': input.label
              } : null
            }));
          case 'logo':
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "switch-label"
            }, /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
              onChange: _this9.handleShowLogo,
              checked: showLogo,
              handleDiameter: 21,
              width: 51,
              height: 25,
              uncheckedIcon: false,
              checkedIcon: false
              // disabled={saveInProgress}
              ,
              offColor: "#BDC2C6",
              onColor: accentColor,
              activeBoxShadow: "0 0 2px 3px ".concat(accentColor)
            }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("label", null, "\xA0 Display your logo"))), showLogo ? /*#__PURE__*/_react.default.createElement("div", {
              className: (0, _classnames.default)('image-row', input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : '', input.value === null && input.optional === true ? 'empty' : '')
            }, /*#__PURE__*/_react.default.createElement(_reactDropzone.default, {
              onDrop: function onDrop(acceptedFiles) {
                console.log(acceptedFiles);
                _this9.handleDropzoneChange(input, acceptedFiles);
              }
            }, function (_ref3) {
              var getRootProps = _ref3.getRootProps,
                getInputProps = _ref3.getInputProps;
              return /*#__PURE__*/_react.default.createElement("section", {
                className: (0, _classnames.default)('dropzone-section')
              }, /*#__PURE__*/_react.default.createElement("div", _extends({}, getRootProps(), {
                className: (0, _classnames.default)('dropzone', input.value === null && (input.optional === null || input.optional === false) ? 'invalid' : '')
              }), /*#__PURE__*/_react.default.createElement("input", _extends({}, getInputProps(), {
                accept: "image/png, image/jpeg, image/gif"
              })), /*#__PURE__*/_react.default.createElement("p", null, input.placeholder)));
            }), input.value ? /*#__PURE__*/_react.default.createElement("div", {
              className: "image-preview"
            }, /*#__PURE__*/_react.default.createElement("img", {
              src: input.value,
              alt: "logo"
            })) : null) : null);
          case 'checkbox':
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "switch-label"
            }, /*#__PURE__*/_react.default.createElement(_reactSwitch.default, {
              onChange: _this9.handleChangeCheckBox.bind(_this9, input.name, !input.value),
              checked: input.value,
              handleDiameter: 21,
              width: 51,
              height: 25,
              uncheckedIcon: false,
              checkedIcon: false
              // disabled={saveInProgress}
              ,
              offColor: "#BDC2C6",
              onColor: accentColor,
              activeBoxShadow: "0 0 2px 3px ".concat(accentColor)
            }), /*#__PURE__*/_react.default.createElement("label", null, "\xA0 ", input.placeholder)));
          case 'percentage':
            return /*#__PURE__*/_react.default.createElement("div", {
              className: "input-row",
              key: input.name
            }, /*#__PURE__*/_react.default.createElement("div", {
              className: "percentage"
            }, /*#__PURE__*/_react.default.createElement("input", {
              className: (0, _classnames.default)(input.value === null && (input.optional === null || input.optional === false) || input.value < percentageMin || input.value > percentageMax ? 'invalid' : ''),
              type: "number",
              min: percentageMin,
              max: percentageMax,
              step: "0.01",
              name: input.name,
              value: input.value ? input.value : '',
              onChange: _this9.handleChange
            }), /*#__PURE__*/_react.default.createElement("div", {
              className: "percent"
            }, "\xA0%"), /*#__PURE__*/_react.default.createElement("div", {
              className: "placeholder"
            }, input.placeholder)));
          default:
            return null;
        }
      }) : null;
      return (
        /*#__PURE__*/
        // Show the button for download
        _react.default.createElement("div", {
          className: "download-pdf"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "accent-color",
          ref: this.styleRef
        }), openModalOnLoad === false ? /*#__PURE__*/_react.default.createElement("button", {
          onClick: this.handleOpenModal
        }, initialButtonText) : null,
        //  Show configuration modal
        openModal && waitingForPdf === false ? /*#__PURE__*/_react.default.createElement("div", {
          onKeyDown: this.handleEnterPress
        }, /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
          open: openModal === true,
          onClose: this.handleCloseModal,
          showCloseIcon: false,
          focusTrapped: false,
          classNames: {
            overlay: 'modal-overlay',
            modal: 'customize-pdf'
          },
          closeOnOverlayClick: true // Stops user from closing when clicking off modal
          ,
          closeOnEsc: true,
          center: true
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "customize-pdf-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "modal-title"
        }, modalTitleText), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
          className: "input-values"
        }, inputFields), /*#__PURE__*/_react.default.createElement("div", {
          className: "action-buttons"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "button-spot"
        }, /*#__PURE__*/_react.default.createElement("button", {
          onClick: this.handleSubmit,
          disabled: !this.allInputsValid()
        }, downloadButtonText)), /*#__PURE__*/_react.default.createElement("div", {
          className: "button-spot"
        }, /*#__PURE__*/_react.default.createElement("button", {
          onClick: this.handleCloseModal
        }, cancelButtonText)))))))

        //  Show waiting modal if pdf generation is in progress
        : waitingForPdf && openModal === false ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_reactResponsiveModal.default, {
          open: waitingForPdf === true,
          showCloseIcon: false,
          onClose: this.handleCloseModal,
          focusTrapped: false,
          classNames: {
            overlay: 'modal-overlay',
            modal: 'waiting-for-pdf'
          },
          closeOnOverlayClick: true // Stops user from closing when clicking off modal
          ,
          closeOnEsc: true,
          center: true
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "waiting-for-pdf-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "waiting-for-pdf-container-message"
        }, errorGeneratingPdf ? '' : waitingMessageText), /*#__PURE__*/_react.default.createElement("div", {
          className: "waiting-for-pdf-container-loading"
        }, errorGeneratingPdf ? /*#__PURE__*/_react.default.createElement("p", null, errorGeneratingPdfText) : /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
          icon: "circle-notch",
          size: "3x",
          className: "waiting-icon",
          spin: true
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "waiting-for-pdf-container-cancel"
        }, /*#__PURE__*/_react.default.createElement("button", {
          onClick: this.handleCloseModal
        }, cancelButtonText))))) : null, openModalOnLoad === true && openModal === false && waitingForPdf === false && showCloseText === true ? /*#__PURE__*/_react.default.createElement("div", {
          className: "close-window"
        }, closeWindowText) : null)
      );
    }
  }]);
  return DownloadPdf;
}(_react.PureComponent);
exports.default = DownloadPdf;
_defineProperty(DownloadPdf, "defaultProps", {
  initialButtonText: 'Download',
  downloadButtonText: 'Download',
  cancelButtonText: 'Cancel',
  modalTitleText: 'Customize Your Document',
  previewText: 'Preview',
  waitingMessageText: 'Please wait while your document is generated',
  closeWindowText: 'You can now close this window',
  token: '',
  dataspanApiUrl: 'https://dataspanapi.wisdomtree.com',
  dpdApiUrl: 'https://dpd.wisdomtree.com',
  clientEmail: '',
  configId: '',
  adhocInputs: null,
  errorGeneratingPdfText: 'There was an error generating your document. Please try again later.',
  submitOnLoad: true,
  isAnonymous: false,
  openModalOnLoad: false,
  showCloseText: true,
  callbackOnClose: null,
  percentageMin: 0,
  percentageMax: 10
});
DownloadPdf.propTypes = {
  /**
   * Text for the initial button added to any app
   */
  initialButtonText: _propTypes.default.string,
  /**
   * Text for the download button
   */
  downloadButtonText: _propTypes.default.string,
  /**
   * Text for the cancel button
   */
  cancelButtonText: _propTypes.default.string,
  /**
   * Text for the title of the customize modal
   */
  modalTitleText: _propTypes.default.string,
  /**
   * Waiting text when the pdf is generating
   */
  waitingMessageText: _propTypes.default.string,
  /**
   * Text for when the window closes
   */
  closeWindowText: _propTypes.default.string,
  /**
   * Token for the DPD/Dataspan APIs (required)
   */
  token: _propTypes.default.string.isRequired,
  /**
   * ID of the Config for the Seismic document. Used to retrieve the config
   * when using the DownloadPdf component
   */
  configId: _propTypes.default.string,
  /**
   * Client Email of the user generating the pdf (required)
   */
  clientEmail: _propTypes.default.string.isRequired,
  /**
   * Dataspan API url
   */
  dataspanApiUrl: _propTypes.default.string,
  /**
   * DPD API url
   */
  dpdApiUrl: _propTypes.default.string,
  /**
   * Error message for pdf generation failure
   */
  errorGeneratingPdfText: _propTypes.default.string,
  /**
   * Optional array of adhoc input values in the form:
   * [{
   *   "name":"family",
   *   "type":"string",
   *   "value":"WisdomTree"
   *  }]
   */
  adhocInputs: _propTypes.default.array,
  /**
   * If you want to force the modal to open then set this prop to false (even if all inputs
   * are satisfied the model will open)
   */
  submitOnLoad: _propTypes.default.bool,
  /**
   * Set to true if the component is to be used anonymously - we don't have a token to 
   * authorize against Dataspan/DPD
   */
  isAnonymous: _propTypes.default.bool,
  /**
   * Open the modal directly and don't show the button
   */
  openModalOnLoad: _propTypes.default.bool,
  /**
   * Show close text when going straight to modal. Only useful if `openModalOnLoad` is set to true
   */
  showCloseText: _propTypes.default.bool,
  /**
   * Optional callback called when modal closes
   */
  callbackOnClose: _propTypes.default.func,
  /**
   * Optional percentage field min
   */
  percentageMin: _propTypes.default.number,
  /**
   * Optional percentage field max
   */
  percentageMax: _propTypes.default.number
};